import React, { useContext } from 'react'
import PrivatePage from '../../components/PrivatePage'
import { isLoggedIn } from '../../lib/utils'
import { AccountContext } from '../../providers/accountProvider'
import WriterContainer from './WritersAcademy.container'
import WritersAcademyUI from './WritersAcademy.UI'

const WriterAcademy = (props) => {
  const { user } = useContext(AccountContext)

  const isUserLogged = isLoggedIn()
  if (!isUserLogged) {
    window?.fcWidget?.hide()
  }

  if (!isUserLogged) 
    return (
      <WriterContainer {...props}>
        <WritersAcademyUI isLoggedIn={isUserLogged}   />
      </WriterContainer>
    )

  return (
    <PrivatePage>
      <WriterContainer {...props}>
        <WritersAcademyUI isLoggedIn={isUserLogged} user={user} />
      </WriterContainer>
    </PrivatePage>
  )
}

export default WriterAcademy
